var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.433 0 0 13.433 0 30C0 46.567 13.433 60 30 60C46.567 60 60 46.567 60 30C60 13.433 46.567 0 30 0ZM27.8571 15.5357C27.8571 15.2411 28.0982 15 28.3929 15H31.6071C31.9018 15 32.1429 15.2411 32.1429 15.5357V33.75C32.1429 34.0446 31.9018 34.2857 31.6071 34.2857H28.3929C28.0982 34.2857 27.8571 34.0446 27.8571 33.75V15.5357ZM30 45C29.1589 44.9828 28.358 44.6366 27.7692 44.0357C27.1804 43.4348 26.8507 42.627 26.8507 41.7857C26.8507 40.9444 27.1804 40.1366 27.7692 39.5357C28.358 38.9348 29.1589 38.5886 30 38.5714C30.8411 38.5886 31.642 38.9348 32.2308 39.5357C32.8196 40.1366 33.1493 40.9444 33.1493 41.7857C33.1493 42.627 32.8196 43.4348 32.2308 44.0357C31.642 44.6366 30.8411 44.9828 30 45Z",
    fill: "#E6E8EC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderClose);
export default __webpack_public_path__ + "static/media/order-close.3d2561f6.svg";
export { ForwardRef as ReactComponent };